/** @format */

import React from 'react';
import { Grid } from '@mui/material';
import { useStyles } from './style';
import { numberWithCommas } from 'utility';
import { PriceLabel } from 'components';

const Overview = ({ data, targetUser, isFromWallet , currencyText}) => {
  const classes = useStyles();

  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      spacing={2}
      item
      xs={12}
      className={classes.root}
    >
      <Grid item xs={12}>

        <li className={classes.listHeadLine}>
          مبلغ:{' '}
          <span className={classes.listHeadLineValue}>
            {data?.amount ? <PriceLabel amount={data.amount} currency={currencyText} /> : '-'}
          </span>
        </li>
        <li className={classes.listHeadLine}>
          تعداد:{' '}
          <span className={classes.listHeadLineValue}>
            {data?.count ? `${numberWithCommas(data?.count)} عدد` : '-'}
          </span>
        </li>
        {!isFromWallet ? (
          <li className={classes.listHeadLine}>
            حساب تفصیلی:{' '}
            <span className={classes.listHeadLineValue}>
              {data?.guildCode ? data.guildCode?.name : '-'}
            </span>
          </li>
        ) : (
          <li className={classes.listHeadLine}>
            حساب دیجیتال:{' '}
            <span className={classes.listHeadLineValue}>
              {data?.wallet ? data.wallet?.label : '-'}
            </span>
          </li>
        )}
        <li className={classes.listHeadLine}>
          تاریخ انقضا:{' '}
          <span className={classes.listHeadLineValue}>
            {data?.expireDate ? data.expireDate?.format('jYYYY/jMM/jDD') : '-'}
          </span>
        </li>
        <li className={classes.listHeadLine}>
          کاربر مجاز به استفاده:{' '}
          <span className={classes.listHeadLineValue}>
            {targetUser?.userId}. {targetUser?.fullName ?? targetUser?.username}
          </span>
        </li>
      </Grid>
    </Grid>
  );
};



export default Overview;
